import React, { Component, Fragment } from 'react';
import { translate } from '../Services/translation';

class AddressList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            removingRow: {},
        };
    }

    onRemoveRequest(rowSystemId, showDeleteButton) {
        this.setState(previousState => ({
            ...previousState,
            removingRow: {
                ...previousState.removingRow,
                [rowSystemId]: showDeleteButton,
            }
        }));
    }
   

    render () {

        const { addresses, onEdit, onRemove } = this.props;
        const { removingRow } = this.state;
        return (
            <div className="simple-table">
                <div className="row medium-unstack no-margin simple-table__header">
                    <div className="columns medium-3">{translate('mypage.address.address2')}</div>
                    <div className="columns medium-3">{translate('mypage.address.careof')}</div>
                    <div className="columns medium-3">{translate('mypage.address.address')}</div>
                    <div className="columns medium-1">{translate('mypage.address.postnumber')}</div>
                    <div className="columns medium-1">{translate('mypage.address.city')}</div>
                    <div className="columns medium-1">{translate('mypage.address.country')}</div>
                    {/*<div className="columns medium-2 hide-for-small-only"></div>*/ }
                </div>
              
                <div className="row medium-unstack no-margin" key={`${address.systemId}`}>
                        <div className="columns"><b>{translate('mypage.address.billing')}</b></div>
                    </div>
                {addresses && addresses.map((address)=> (
                    address.addressType==='Billing'?
                    <div className="row medium-unstack no-margin" key={`${address.systemId}`}>
                        <div className="columns medium-3">{address.address2}</div>
                        <div className="columns medium-3">{address.careOf}</div>
                        <div className="columns medium-3">{address.address}</div>
                        <div className="columns medium-1">{address.zipCode}</div>
                        <div className="columns medium-1">{address.city}</div>
                        <div className="columns medium-1">{address.country}</div>
                        {/*  <div className="columns medium-2">
                            { false && <a className="table__icon table__icon--edit" onClick={() => onEdit(address)} title={translate('Edit')}></a>}
                            { false && !removingRow[address.systemId] && <a className="table__icon table__icon--delete" onClick={() => this.onRemoveRequest(address.systemId, true)} title={translate('Remove')}></a>}
                            { false && removingRow[address.systemId] && <a className="table__icon table__icon--accept" onClick={() => onRemove(address.systemId)} title={translate('Accept')}></a>}
                            { false && removingRow[address.systemId] && <a className="table__icon table__icon--cancel" onClick={() => this.onRemoveRequest(address.systemId, false)} title={translate('Cancel')}></a>}
                             </div>*/ }
                    </div>
                    :null
                ))}
                <div className="row medium-unstack no-margin" key={`${address.systemId}`}>
                        <div className="columns"><b>{translate('mypage.address.delivery')}</b></div>
                        
                    </div>
                    {addresses && addresses.map((address)=> (
                    address.addressType==='Delivery'?
                    <div className="row medium-unstack no-margin" key={`${address.systemId}`}>
                        <div className="columns medium-3">{address.address2}</div>
                        <div className="columns medium-3">{address.careOf}</div>
                        <div className="columns medium-3">{address.address}</div>
                        <div className="columns medium-1">{address.zipCode}</div>
                        <div className="columns medium-1">{address.city}</div>
                        <div className="columns medium-1">{address.country}</div>
                        {/* <div className="columns medium-2">
                            { false && <a className="table__icon table__icon--edit" onClick={() => onEdit(address)} title={translate('Edit')}></a>}
                            { false && !removingRow[address.systemId] && <a className="table__icon table__icon--delete" onClick={() => this.onRemoveRequest(address.systemId, true)} title={translate('Remove')}></a>}
                            { false && removingRow[address.systemId] && <a className="table__icon table__icon--accept" onClick={() => onRemove(address.systemId)} title={translate('Accept')}></a>}
                            { false && removingRow[address.systemId] && <a className="table__icon table__icon--cancel" onClick={() => this.onRemoveRequest(address.systemId, false)} title={translate('Cancel')}></a>}
                        </div>*/ }
                    </div>
                    :null
                ))}
            </div>
        );
    }
}

export default AddressList;